import React from 'react';
import { Divider, Form, Radio, Label } from 'semantic-ui-react';
import { MenuItemVariationPropType } from '../../../services/proptypes';
var defaultProps = {
  showDivider: true,
  checkoutDisabled: false
};
var VariationSelection = function VariationSelection(_ref) {
  var variations = _ref.variations,
    selectedVariation = _ref.selectedVariation,
    onSelectVariation = _ref.onSelectVariation,
    showDivider = _ref.showDivider,
    checkoutDisabled = _ref.checkoutDisabled;
  return /*#__PURE__*/React.createElement("div", {
    className: "item-cart-variation-selection"
  }, showDivider && /*#__PURE__*/React.createElement(Divider, null), /*#__PURE__*/React.createElement("div", {
    className: "variation-selection-header"
  }, /*#__PURE__*/React.createElement("h5", null, "CHOOSE A TYPE"), /*#__PURE__*/React.createElement(Label, {
    color: "blue"
  }, "REQUIRED")), /*#__PURE__*/React.createElement(Form, null, variations.map(function (_ref2, index) {
    var name = _ref2.name,
      price = _ref2.price;
    return /*#__PURE__*/React.createElement("div", {
      className: "variation-selection-radio",
      key: name
    }, /*#__PURE__*/React.createElement(Form.Field, null, /*#__PURE__*/React.createElement(Radio, {
      disabled: checkoutDisabled,
      label: name,
      name: "variation",
      value: "this",
      checked: "".concat(name).concat(price) === "".concat(selectedVariation.name).concat(selectedVariation.price),
      onChange: function onChange() {
        return onSelectVariation(index);
      }
    })), /*#__PURE__*/React.createElement("div", null, price && +price !== 0 ? "$".concat((+price).toFixed(2)) : '-'));
  })));
};
VariationSelection.defaultProps = defaultProps;
export default VariationSelection;